export const draftStatus = status => status && status.toLocaleLowerCase() === 'draft'
export const confirmedStatus = status => status && status.toLocaleLowerCase() === 'confirmed'
export const warningStatus = (status) =>
  status && ['draft', 'pending eligibility', 'pending'].includes(status.toLocaleLowerCase())
export const receivedStatus = (status) => status && status.toLocaleLowerCase() === 'received'



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/view/helper.js